const Config = {
  ROSBRIDGE_SERVER_IP: "",
  ROSBRIDGE_SERVER_PORT: "9090",
  RECONNECTION_TIMER: 3000,
  CMD_VEL_TOPIC: "/cmd_vel",
};

export default Config;

//   Function to update rosbridge server ip adn export
export const updateRosbridgeServerIp = (ip) => {
  Config.ROSBRIDGE_SERVER_IP = ip;
};
